export function onlyNumbersString(text: string) {
  return text.replace(/[^\d]/g, '')
}
